import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { Pagination } from "components";
import { DatetimeUtils } from "utils";
import MessageStatus from "./MessageStatus";
import MessageAction from "./MessageAction";

const Datatable = ({ botMessageList, isLoading, pagination, onChangePage, refetch }) => {
  const { t: getLabel } = useTranslation();

  const getShowTime = message => {
    if (message.time && message.time > 0) {
      return DatetimeUtils.convertMillisecondsToDateTime(message.time);
    }
    if (message.modified && message.modified > 0) {
      return DatetimeUtils.convertMillisecondsToDateTime(message.modified);
    }
    return DatetimeUtils.convertMillisecondsToDateTime(message.created);
  };

  const currentPage = pagination.offset / pagination.limit + 1;
  const totalPages = pagination.total_pages;

  const handlePageChange = page => {
    onChangePage(null, page);
  };

  return (
    <Fragment>
      <div style={{ marginTop: "16px", marginBottom: "16px" }}>
        <table className="table table-vcenter" style={{ minWidth: "650px", whiteSpace: "nowrap", tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th style={{ width: "40%", fontWeight: "bold" }}>{getLabel(LangConstant.TXT_MEDIA_COL_MESSAGE)}</th>
              <th style={{ width: "20%", fontWeight: "bold", textAlign: "center" }}>{getLabel(LangConstant.TXT_MEDIA_COL_STATUS)}</th>
              <th style={{ width: "20%", fontWeight: "bold", textAlign: "center" }}>{getLabel(LangConstant.TXT_MEDIA_COL_TIME)}</th>
              <th style={{ width: "20%", fontWeight: "bold", textAlign: "center" }}>{getLabel(LangConstant.TXT_MEDIA_COL_ACTION)}</th>
            </tr>
          </thead>

          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>
                  <small>{getLabel(LangConstant.TXT_LOADING)}</small>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {botMessageList?.length > 0 ? (
                botMessageList.map((message, index) => (
                  <tr key={index}>
                    <td style={{ whiteSpace: "normal", overflowWrap: "break-word" }}>{message.content}</td>
                    <td style={{ whiteSpace: "normal", overflowWrap: "break-word", textAlign: "center" }}>
                      <MessageStatus status={message.status} />
                    </td>
                    <td style={{ textAlign: "center" }}>{getShowTime(message)}</td>
                    <td style={{ whiteSpace: "normal", overflowWrap: "break-word", textAlign: "center" }}>
                      <MessageAction message={message} refetchList={refetch} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>
                    <small>
                      <i>{getLabel(LangConstant.TXT_NOT_FOUND)}</i>
                    </small>
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>
      {totalPages > 0 && (
        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={(e, p) => handlePageChange(p)} />
      )}
    </Fragment>
  );
};

export default Datatable;
